<template>
    <b-modal
        id="modal-seleccionar-archivo"
        ref="my-modal"
        title="Selecione un archivo"
        no-close-on-backdrop
        ok-title="Insertar"
        cancel-variant="outline-secondary"
        cancel-title="Cerrar"
        size="xl"
        :ok-disabled="selected==''"
        @ok.prevent="validarSeleccionar"
    >
    <Index @selectItemMedia="selectItemMedia" id="scroll"/>
    <template #modal-footer>
        <b-button
          variant="outline-secondary"
          @click="cerrarModal()"
        >
          Cerrar
        </b-button>
        <b-button
          variant="primary"
          @click="validarSeleccionar()"
          :disabled="selected==''"
        >
          Insertar
        </b-button>
        <b-button
          v-if="selected.tipo=='DOCUMENTO'"
          variant="primary"
          @click="validarSeleccionarDocumentoEnlace()"
          :disabled="selected==''"
        >
          Insertar enlace
        </b-button>
    </template>
  </b-modal>
</template>
<script>
import axiosIns from '@/libs/axios'
import {
  BButton, BModal, VBModal
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { $themeColors } from '@themeConfig'
import Index from "@/views/aplicaciones/medios/Index.vue";

export default {
  components: {
    BButton,
    BModal,
    Index,
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
  data() {
    return {
        selected:'',
    }
  },
  created() {

  },
  watch: {

  },
  methods: {
    cerrarModal(){
      this.selected='';
      this.$nextTick(() => {
          this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },
    selectItemMedia(item){
      this.selected=item;
    },
    validarSeleccionar(){
      this.$nextTick(() => {
          this.$refs['my-modal'].toggle('#toggle-btn')
      })
      this.$emit('enviarMedia',this.selected);
    },
    validarSeleccionarDocumentoEnlace(){
      this.selected.tipo="DOCUMENTO ENLACE";
      this.$nextTick(() => {
          this.$refs['my-modal'].toggle('#toggle-btn')
      })
      this.$emit('enviarMedia',this.selected);
    }
  },
}
</script>
<style lang="scss">
#scroll{
  .scroll-area1 {
    height: calc(var(--vh, 1vh) * 100 - 23rem) !important;
    overflow: hidden;
  }
}
#modal-seleccionar-archivo{
  .modal-body {
      padding: 0rem !important;
  }
  .card{
    margin-bottom: 0rem !important;
  }
  .card-body {
      padding: 1rem;
  }
  #card-media{
    margin-bottom: 2rem !important;
  }
}

</style>
